module.exports = __webpack_public_path__ + "img/category-new-released-hover.21c30f0e.png";